<!--查看详情界面-->
<template lang="pug">
    el-dialog(
        title="查看场地"
        class="el-dialog-custom"
        top="3vh"
        width="95%"
        :close-on-click-modal="false"
        :append-to-body="true"
        @close="closeDialog(false)"
        :visible.sync="vaisible"
    )
        el-card(shadow="never")
            div.clearfix(slot="header")
                span.fontStyle 场地设置
            el-form(:model="dataForm" ref="dataForm" label-suffix=":" label-width="170px")
                    el-form-item(label="场地名称" prop="name")
                        el-input.width_ct(v-model="dataForm.name" placeholder="请填写场地名称" disabled)
                    el-form-item(label="联系电话" prop="contactMobile")
                        el-input.width_ct(v-model="dataForm.contactMobile" placeholder="请填写联系电话" disabled)
                    el-form-item(label="小程序最多预定天数" prop="subscribeDays")
                        el-input.width_ct(v-model="dataForm.subscribeDays" placeholder="请填写小程序最多预定天数" disabled)
                    el-form-item(label="场地属性" prop="type")
                        el-input.width_ct(v-model="dataForm.typeLabels" placeholder="请填写场地属性"  disabled)
                    el-form-item(label="会员类型" prop="memberType")
                        el-input.width_ct(v-model="dataForm.memberTypeLabels" placeholder="请填写会员类型" disabled)
                    el-form-item(label="注册会员单日单片限制")
                        el-input.width_ct(v-model="dataForm.registerMemberLimit" placeholder="请填写注册会员单日单片限制" disabled)
                    el-form-item(label="初始会员单日单片限制")
                        el-input.width_ct(v-model="dataForm.juniorMemberLimit" placeholder="请填写初始会员单日单片限制" disabled)
                    el-form-item(label="荣誉会员单日单片限制")
                        el-input.width_ct(v-model="dataForm.honorMemberLimit" placeholder="请填写荣誉会员单日单片限制" disabled)
                    el-form-item(label="价格说明" prop="priceDescription")
                        el-input.width_ct(v-model="dataForm.priceDescription" type="textarea" :rows=6 placeholder="请填写价格说明" disabled)
                    el-form-item(label="详细地址" prop="address")
                        el-input.width_ct(v-model="dataForm.address" type="textarea" :rows=3 placeholder="" disabled)
                    el-form-item(label="列表页图:" prop="imgList")
                        img(:src="dataForm.displayImageUrl" :onerror="defaultImg" style="width: 256px; height: 190px;")
                    el-form-item(label="顺序" prop="sortNum")
                        el-input-number.width_ct(v-model="dataForm.sortNum" disabled)
        //- el-card(shadow="never")
        //-     div.clearfix(slot="header")
        //-         span.fontStyle 场地价格设置
        //-     div.container
        //-     el-table(:data="siteDetailData" style="width: 100%;" border)
        //-         el-table-column(type="index" header-align="center" align="center" label="序号" width="50")
        //-         el-table-column(header-align="center" align="center" label="场地属性")
        //-             template(slot-scope="scope")
        //-                font {{ siteAttributesArray.filter(ele => { if(ele.code === scope.row.type.toString()) { return ele } })[0].name }}
        //-         el-table-column(prop="number" header-align="center" align="center" label="场地号")
        //-         el-table-column(prop="openDate" header-align="center" align="center" label="日期")
        //-         el-table-column(header-align="center" align="center" label="时间段")
        //-             template(slot-scope="scope")
        //-                font {{ scope.row.startTime }} - {{ scope.row.endTime }}
        //-         el-table-column(prop="price" header-align="center" align="center" label="场地价格/元/小时")
        el-card(shadow="never")
            div.clearfix(slot="header")
                span.fontStyle 会员定场价格设置
            div
                el-table(:data="clubMemberPriceData" border)
                    el-table-column(prop="memberTypeLabel" label="角色" align="center")
                    el-table-column(prop="reduceAmount" label="定场价格优惠" align="center")
                        template(slot-scope="scope")
                            font ￥&nbsp;&nbsp;
                            el-input-number(v-model ="scope.row.reduceAmount" :precision="2" :min="-10000000" :max="0" disabled)
                            font &nbsp;&nbsp;&nbsp;&nbsp;元
        el-card(shadow="never")
            div.clearfix(slot="header")
                span.fontStyle 退款设置
            div
                el-table(:data="refundData" border)
                    //- el-table-column(type="selection", align="center", width="50")
                    el-table-column(type="index" label="序号"  align="center", width="50")
                    el-table-column(prop="hours" label="距比赛开始时间/小时（含）" align="center")
                    el-table-column(prop="rate" label="退款比例/%" align="center")
        span.dialog-footer(slot="footer")
            el-button(@click="closeDialog(false)") 取 消
        <!-- 选择模板通用组件 -->
        addFeeTemplate(v-if="addFeeTemplateVisible" ref="addFeeTemplate" @chooseTemplate="chooseTemplate")
</template>

<script>
import addFeeTemplate from '../operation/fee/add-fee-template.vue'

export default {
    name: 'AddOrUpdate',
    components: {
        addFeeTemplate
    },
    props: {
        vaisible: {
            type: Boolean
        },
        placeId: {
            type: String,
            default: ''
        },
        memberTypeArray: {
            type: Array,
            default: () => []
        },
        siteAttributesArray: {
            type: Array,
            default: () => []
        }
    },
    created () {
        // 修改操作,初始化操作
        if (this.placeId) {
            // 获取约场地详情
            this.getPlaceDetailData()
            // 获取约场地明细列表
            // this.getPlacePriceData()
            // 获取约场地会员价格列表
            this.getPlaceClubUserData()
            // 获取约场地退款设置列表
            this.getPlaceRefoundsData()
        }
    },
    data () {
        return {
            delCtRefundDisabled: false,
            aaa: [{ name: '开发测试' }],
            ctRefund: {},
            // 界面参数
            dataForm: { name: '', type: '', memberType: '', priceDescription: '' },
            nameFont: 40,
            siteDetailData: [], // 场地价格明细设置数据
            chooseSiteDetailData: [], // 选择的场地价格明细设置数据
            chooseRefoundData: [], // 选择的退款数据
            sitePriceDetailParams: {
                //  场地价格明细设置参数对象
                no: '',
                number: '',
                price: '',
                type: '',
                startTime: '',
                endTime: ''
            },
            clubMemberPriceData: [
                { id: null, memberTypeLabel: '注册会员', memberType: 1, reduceAmount: 0.0 },
                { id: null, memberTypeLabel: '初始会员', memberType: 2, reduceAmount: 0.0 },
                { id: null, memberTypeLabel: '荣誉会员', memberType: 3, reduceAmount: 0.0 }
            ], // 会员定场价格设置数据
            addFeeTemplateVisible: false,
            refundData: [], // 退款数据集合
            defaultImg: ''
        }
    },
    methods: {
        closeDialog (val) {
            this.$emit('update:vaisible', val)
        },
        // 获取场地详情接口
        getPlaceDetailData () {
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/${this.placeId}`),
                method: 'get',
                params: this.$http.adornParams({ id: this.placeId })
            })
            .then(data => {
                if (data && data.code === 0) {
                    this.dataForm = data.data
                }
            })
        },
        // 获取约场地价格明细列表
        getPlacePriceData () {
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/item-list/${this.placeId}`),
                method: 'get',
                params: this.$http.adornParams({ id: this.placeId })
            })
            .then(data => {
                if (data && data.code === 0) {
                    this.siteDetailData = data.data
                    this.siteDetailData = data.data.map(ele => {
                        // 解决后台不能识别24点得问题,前端将其转换成23:59
                        if (ele.endTime === '23:59') {
                            ele.endTime = '24:00'
                        }
                        return ele
                    })
                    // 排序
                    // this.siteDetailData = this.siteDetailData.sort((pre, next) => {
                    //      return +pre.type - +next.type
                    // })
                }
            })
        },
        // 获取约场地会员价格列表
        getPlaceClubUserData () {
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/member-price-list/${this.placeId}`),
                method: 'get',
                params: this.$http.adornParams({ id: this.placeId })
            })
            .then(data => {
                if (data && data.code === 0) {
                    this.clubMemberPriceData = data.data
                    // 排序
                    this.clubMemberPriceData = this.clubMemberPriceData.sort((pre, next) => {
                            return pre.memberType - next.memberType
                        }
                    )
                }
            })
        },
        // 获取约场地退款设置列表
        getPlaceRefoundsData () {
            this.$http({
                url: this.$http.adornUrl(`/bp-book-places/refund-percent-list/${this.placeId}`),
                method: 'get',
                params: this.$http.adornParams({ id: this.placeId })
            })
            .then(data => {
                if (data && data.code === 0) {
                    let no = 1
                    this.refundData = data.data.map(ele => {
                        ele.index = no++
                        return ele
                    })
                }
            })
        }
    }
}
</script>

<style scoped>
.el-dialog-custom {
    overflow: hidden !important;
}
.el-dialog-custom /deep/ .el-dialog__body {
    height: 73vh;
    overflow: auto;
}
.el-dialog-custom /deep/ .el-dialog__footer {
    border-top: 1px solid #E9E9E9;
}

.son-container {
  flex-grow: 1;
  display: flex;
  margin-bottom: 20px;
}

.container {
  display: flex;
  justify-content: space-between;
}

.fontStyle {
  font-weight: bold;
  font-size: 18px;
}

.width_ct {
  width: 50%;
}

.sel_width_ct,
.input_width_ct {
  width: 20% !important;
}

.input_title {
  width: 80px;
  flex-shrink: 0;
}

.buttonStyle {
  width: 200px;
  text-align: center;
  flex-shrink: 0;
}
</style>
